import { TAU } from "./math";
import { SPRING, SUMMER, AUTUMN, WINTER, getCurrentSeason } from "./seasons";

const r = (1+Math.sqrt(5))/2;
const r2 = r*r;
const r3 = r*r*r;
const r4 = r*r*r*r;
const r5 = r*r*r*r*r;

const LEN = 150;
const WIDTH = 30;

/**
 * Effect configuration
 * 
 * @type {{fullOpacity: number, frostLimit: number, scale: number, decayRate: number, initialSeason: number, segments: *[], minOpacity: number, grassLength: number, leafWindFactor: number[], grass: {bladesMin: number, flowers: {position: number, variants: string[], render: render}[], bladeMinHeight: number, tileWidth: number, bladeMaxHeight: number, bendLocality: number, flowerRatio: number, numTiles: number, bend: number, layers: number, heightVariance: number, bladesMax: number, tileHeight: number}, angle: number, grassCount: number, windStrength: number[], radiuses: *[], start: *[], decaySize: number, fullCrownSize: number, maxLeaf: number, minCrownSize: number, horizon: number, viewBox: string, seasonLength: number, gravity: number, minLeaf: number, numLeafs: number[]}}
 */
const TreeAnimConfig = {

    // trees are drawn inside [0,0 ... 1000,1000], this renders it a bit higher for design reasons
    viewBox: "0 15 1000 1000",


    start: ["center","center", -TAU / 4],

    angle: TAU * 0.125,

    segments: [ LEN, LEN /r, LEN / r2, LEN / r3, LEN/ r4, LEN/r5],
    radiuses: [ WIDTH, WIDTH /r, WIDTH / r2, WIDTH / r3, WIDTH/ r4, WIDTH/r5],

    gravity: 4,

    minLeaf: 0.1,
    maxLeaf: 0.5,

    numLeafs: [500,100, 100, 500],
    leafWindFactor: [0.01,0.01,0.05,0.02],

    windStrength: [ 0.2, 0.1, 0.5, 0.01],
    horizon: 0.61,

    frostLimit: 80,

    /*
        Decay: Run the color withering algorithm <decayRate> times per frame, on a random area of <decaySize> squared
        setting this higher might slow the simulation down
    */
    decayRate: 13,
    decaySize: 40,

    seasonLength: 60 * 45,

    fullCrownSize: 50,
    fullOpacity: 0.4,
    minCrownSize: 8,
    minOpacity: 0.3,

    initialSeason: AUTUMN,//getCurrentSeason(),

    scale: window && window.innerWidth > 1024 ? 2 : 1,

    grassCount: 100,
    grassLength: 50,

    grass: {
        tileWidth: 58,
        tileHeight: 64,
        numTiles: 50,

        /* random bend in ground pixel units (to both sides)*/
        bend: 14,

        bladeMinHeight: 0.4,
        bladeMaxHeight: 0.9,

        bladesMin: 7,
        bladesMax: 9,
        layers: 3,

        heightVariance: 6,

        /* relative amount of the bend that is determined by a local bend factor and not the global bend 0...1 */
        bendLocality: .5,

        flowerRatio: 0.15,
        flowers: [
            {
                // position on blade curve 0..1
                position: 1.0,
                // variants one of which is chosen at random
                variants: [
                    "#f2f7fa",
                    "#f0d330",
                    "#f01a1a",
                    "#c8c"
                ],
                // standard flower render signature
                render: (ctx, config, pos, color) => {

                    ctx.fillStyle = color;
                    ctx.fillRect(pos.x- 1.5, pos.y - 1.5, 3, 3);
                }
            }
        ]
    }
};


export  default TreeAnimConfig;
